/* global femcare */

femcare.navigation.navigationMain = {
    $menuModal: $('.modal--navigation'),
    $submenuToggleButtons: $('.navigation-bar__topic[aria-haspopup]'),
    openMenuButton: document.querySelector('.navigation-bar__icon--open'),
    closeMenuButton: document.querySelector('.navigation-bar__icon--close'),

    /**
     * Initialize all navigation behaviors.
     */
    init() {
        if ($('.navigation').length) {
            this.setupDesktopNavigation();
            this.setupLanguageMenu();
            this.adjustSampleItemText();
            if (this.openMenuButton && this.closeMenuButton) {
                this.openMobileMenu();
                this.closeMobileMenu();
            }
        }
    },

    /**
     * Setup desktop navigation: sticky header + submenu hover/click.
     */
    setupDesktopNavigation() {
        this.setupStickyNavigation();

        this.$submenuToggleButtons.on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            const $toggle = $(e.currentTarget);
            if ($toggle.hasClass('open')) {
                this.closeNavigationDropdown();
            } else {
                this.openNavigationDropdown($toggle);
            }
        });

        this.$submenuToggleButtons
            .parent()
            .on('mouseenter', e => {
                const $toggle = $(e.currentTarget).find('.navigation-bar__topic[aria-haspopup]');
                this.openNavigationDropdown($toggle);
            })
            .on('mouseleave', () => {
                this.closeNavigationDropdown();
            });

        // Bind the Escape key to close any open navigation dropdown.
        $(document).on('keydown.navigationMain', e => {
            if (e.key === 'Escape') {
                this.closeNavigationDropdown();
            }
        });
    },

    /**
     * Setup language popout toggle and click-outside-to-close behavior.
     */
    setupLanguageMenu() {
        const $languageContainer = $('.navigation-bar__language');
        const $toggle = $('.navigation-bar__language-toggle');
        const $popout = $('.navigation-bar__language-popout');

        $toggle.on('click', (e) => {
            e.preventDefault();
            const isOpen = $popout.is(':visible');

            if (isOpen) {
                this.closeLanguagePopout($languageContainer, $popout, $toggle);
            } else {
                this.openLanguagePopout($languageContainer, $popout, $toggle);
            }
        });
    },

    /**
     * Open the language popout and setup close handlers.
     * @param {jQuery} $languageContainer The language container element
     * @param {jQuery} $popout The popout element
     * @param {jQuery} $toggle The toggle button
     */
    openLanguagePopout($languageContainer, $popout, $toggle) {
        $languageContainer.addClass('displayed');
        $popout.addClass('displayed');
        $toggle.attr('aria-expanded', 'true');

        // Close on Escape
        $(document).on('keydown.languagePopout', (e) => {
            if (e.key === 'Escape') {
                this.closeLanguagePopout($languageContainer, $popout, $toggle);
                $toggle.trigger('focus');
            }
        });

        // Close when focus moves outside
        setTimeout(() => {
            $popout.find('button, a, [tabindex]').on('blur', () => {
                this.handleLanguagePopoutBlur($languageContainer, $popout, $toggle);
            });
        }, 0);
    },

    /**
     * Close the language popout and remove event handlers.
     * @param {jQuery} $languageContainer The language container element
     * @param {jQuery} $popout The popout element
     * @param {jQuery} $toggle The toggle button
     */
    closeLanguagePopout($languageContainer, $popout, $toggle) {
        $languageContainer.removeClass('displayed');
        $popout.removeClass('displayed');
        $toggle.attr('aria-expanded', 'false');
        $(document).off('keydown.languagePopout');
    },

    /**
     * Handle blur event for language popout to close when focus leaves.
     * @param {jQuery} $languageContainer The language container element
     * @param {jQuery} $popout The popout element
     * @param {jQuery} $toggle The toggle button
     */
    handleLanguagePopoutBlur($languageContainer, $popout, $toggle) {
        setTimeout(() => {
            if (
                !$.contains($popout[0], document.activeElement) &&
                document.activeElement !== $toggle[0]
            ) {
                this.closeLanguagePopout($languageContainer, $popout, $toggle);
            }
        }, 10);
    },

    /**
     * Open the main navigation and bind blur handlers to close when focus leaves.
     * @param {jQuery} $toggle The submenu toggle that triggered open
     */
    openNavigationDropdown($toggle) {
        $('.navigation').addClass('open');
        this.showSubmenu($toggle);

        this.$submenuToggleButtons.parent().each((_, parent) => {
            const $parent = $(parent);
            $parent.find('a').on('blur', () => {
                setTimeout(() => {
                    if (!$.contains(parent, document.activeElement)) {
                        this.closeNavigationDropdown();
                    }
                }, 10);
            });
        });
    },

    /**
     * Close the main navigation and unbind all related event handlers.
     */
    closeNavigationDropdown() {
        $('.navigation').removeClass('open');
        this.hideSubmenu();
        $('html').off('click');
        this.$submenuToggleButtons.parent().find('a').off('blur');
    },

    /**
     * Show the given submenu toggle's submenu.
     * @param {jQuery} $toggle The submenu toggle to open
     */
    showSubmenu($toggle) {
        this.hideSubmenu();
        $toggle
            .addClass('open')
            .attr('aria-expanded', true);
        $toggle.parent()
            .find('.navigation-bar__submenu')
            .stop(true, true)
            .show()
            .addClass('open');
    },

    /** Hide any open submenu. */
    hideSubmenu() {
        this.$submenuToggleButtons
            .removeClass('open')
            .attr('aria-expanded', false);
        $('.navigation-bar .navigation-bar__submenu')
            .hide()
            .removeClass('open');
    },

    /** Show the mobile menu open button and hide the close button. */
    openMobileMenu() {
        this.openMenuButton.addEventListener('click', () => {
            this.openMenuButton.classList.add('hidden');
            this.closeMenuButton.classList.remove('hidden');
        });
    },

    /** Hide the mobile menu and toggle open/close buttons. */
    closeMobileMenu() {
        this.closeMenuButton.addEventListener('click', () => {
            this.$menuModal.removeClass('displayed');
            this.closeMenuButton.classList.add('hidden');
            this.openMenuButton.classList.remove('hidden');
        });
    },

    /** Bind window resize to sticky behavior and initialize it immediately. */
    setupStickyNavigation() {
        $(window).on('resize', this.handleStickyNavigation);
        this.handleStickyNavigation();
    },

    /** Apply or remove sticky (affix) classes based on scroll position. */
    handleStickyNavigation() {
        const $nav = $('.navigation');
        if (!femcare.shared.util.isRichNavbarActive()) {
            return;
        }

        const navHeight = $nav.outerHeight();
        if ($(window).scrollTop() > navHeight) {
            $nav.addClass('affix');
        }
        $nav.affix({ offset: { top: navHeight } });
    },

    /**
     * Adjust the sample icon/label sizes based on rendered width
     * to add “large-text” modifiers when needed.
     */
    adjustSampleItemText() {
        const $iconsContainer = $('.navigation-bar__half--first .navigation-bar__icons');
        const $label = $iconsContainer.find('.navigation-bar__icon--primary span');
        const $sampleIcon = $('.navigation .navigation-bar__topic .icon-sample');

        if ($sampleIcon.length) {
            const $topic = $sampleIcon.closest('.navigation-bar__topic');
            const width = $topic.width();
            if (width > 98 || width === 0) {
                $topic.addClass('navigation-bar__topic--large-text');
            }
        }

        if ($label.length) {
            const labelWidth = $label.width();
            if (labelWidth > 108 || labelWidth === 0) {
                $iconsContainer.addClass('navigation-bar__icons--large-text');
            }
        }
    }
};
